import React, { useState } from "react";
import TableAbstraction from "../componentUtils/TableAbstraction";
import { formatDate } from "../utils/Formatter";

function EFRHistory(props: any) {
  const [muiTable, setMuiTable] = useState<any>({ rpp: 25 });
  const [EFRData, setEFRData] = useState<any>([]);

  React.useEffect(() => {
    const efrData = props.EFRData;
    const settlement = props.settlement;
    var flag_value: any[] = [];
    var flag_ticket = false;

    efrData.map((e: any) => {
      settlement.forEach((o: any) => {
        if (e.visit_dt === o.visitDt) {
          var totalFillUnits = 0;
          var totalClosingInv = 0;
          o?.txSettlementItems?.forEach((sitem: any, index: number) => {
            totalFillUnits += sitem.quantity;
            totalClosingInv += sitem.closingInventory;
          });
          e.fillRate = totalClosingInv > 0 ? Math.ceil((totalFillUnits / totalClosingInv) * 100) : 0;
          e.diff_from_prediction = Math.ceil(e.predicted_value_rate - e.fillRate);
          if (e.isVendPrimeSettlement || e.ticket_num) {
            e.avg_efr = "";
            flag_value = [];
            flag_value.push(e.fillRate);
          } else {
            flag_value.push(e.fillRate);
            e.avg_efr = Math.ceil(flag_value.reduce((a, b) => a + b, 0) / flag_value.length);
          }
        }
      });
    });

    efrData.map((e: any) => {
      if (e.isVendPrimeSettlement || e.ticket_num) {
        flag_ticket = true;
      }
      if (!flag_ticket) {
        e.predicted_value_rate = "";
      }
    });

    setEFRData(efrData);
    return () => {
      setEFRData([]);
    };
  }, [props.EFRData, props.settlement]);

  return (
    <div>
      <TableAbstraction
        settingsKey="VP_RM"
        options={{
          draggableColumns: {
            enabled: true,
          },
          rowsPerPageOptions: [25, 50, 100],
          serverSide: false,
          selectableRows: "none",
          rowsPerPage: muiTable.rpp,
          onChangeRowsPerPage: (numberOfRows) => {
            muiTable.rpp = numberOfRows;
            setMuiTable(muiTable);
          },
        }}
        title={`EFR History ${props.title}`}
        columns={[
          {
            label: "Visit Date",
            name: "visit_dt",
            options: {
              searchable: true,
              filter: false,
              customBodyRender: (value: any) => {
                return `${value ? formatDate(value, "MM/DD/YYYY", '/') : ""}`;
              },
            },
          },
          {
            label: "Is VendPrime",
            name: "isVendPrimeSettlement",
            options: {
              searchable: true,
              filter: false,
            },
          },
          {
            label: "Current EFR %",
            name: "fillRate",
            options: {
              searchable: true,
              filter: false,
              customBodyRender: (value: any) => value + "%",
            },
          },
          {
            label: "Predicted EFR %",
            name: "predicted_value_rate",
            options: {
              searchable: true,
              filter: false,
              customBodyRender: (value: any) => (value !== "" ? value + "%" : ""),
            },
          },
          {
            label: "Average EFR Since S2S",
            name: "avg_efr",
            options: {
              searchable: true,
              filter: false,
              customBodyRender: (value: any) => (value !== "" ? value + "%" : ""),
            },
          },
          {
            label: "Difference from Prediction",
            name: "diff_from_prediction",
            options: {
              searchable: true,
              filter: false,
              customBodyRender: (value: any) => (value !== "" ? value + "%" : ""),
            },
          },
          {
            label: "Request Num",
            name: "request_num",
            options: {
              searchable: true,
              filter: true,
            },
          },
          {
            label: "Order Num",
            name: "order_num",
            options: {
              searchable: true,
              filter: true,
            },
          },
          {
            label: "SAP Request Number",
            name: "sap_request_number",
            options: {
              searchable: true,
              filter: true,
            },
          },
          {
            label: "SAP Ticket Number",
            name: "ticket_num",
            options: {
              searchable: true,
              filter: true,
            },
          },
          {
            label: "SAP Ticket Status",
            name: "ticket_status",
            options: {
              searchable: true,
              filter: true,
            },
          },
        ]}
        data={EFRData}
      />
    </div>
  );
}

export default EFRHistory;
